export default __webpack_public_path__ + "static/media/screenthinker.ea12ca6a.png";